// import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { getDatabase, ref, get, update } from "firebase/database";

// const TestComponent = () => {
//   const { userObjectKey } = useParams();
//   const db = getDatabase();

//   const [location, setLocation] = React.useState({ latitude: null, longitude: null });
//   const [userExists, setUserExists] = React.useState(true);

//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLocation({
//             latitude: position?.coords?.latitude,
//             longitude: position?.coords?.longitude,
//           });
//         },
//         (error) => {
//           console.error("Error getting location", error);
//         }
//       );
//     } else {
//       console.error("Geolocation is not supported by this browser.");
//     }
//   }, []);

//   useEffect(() => {
//     if (userObjectKey && location.latitude && location.longitude) {
//       const userRef = ref(db, `users/${userObjectKey}`);

//       // Check if user exists
//       get(userRef)
//         .then((snapshot) => {
//           if (snapshot.exists()) {
//             setUserExists(true);

//             const userData = snapshot.val(); // Get the existing user data

//             // Only add the new fields if they do not already exist
//             if (
//               !userData.hasOwnProperty("changeLatitude") ||
//               !userData.hasOwnProperty("changeLongitude")
//             ) {
//               const updates = {};
//               if (!userData.hasOwnProperty("changeLatitude")) {
//                 updates["changeLatitude"] = location?.latitude;
//               }
//               if (!userData.hasOwnProperty("changeLongitude")) {
//                 updates["changeLongitude"] = location?.longitude;
//               }

//               // Update only the new fields without modifying existing ones
//               update(userRef, updates)
//                 .then(() => {
//                   console.log("Location added successfully!");
//                 })
//                 .catch((error) => {
//                   console.error("Error adding location:", error);
//                 });
//             }
//           } else {
//             setUserExists(false);
//             console.log("User does not exist!");
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching user data:", error);
//         });
//     }
//   }, [userObjectKey, location]);

//   return (
//     <div>
//       <h2>Test Page</h2>
//       <p>User Object Key: {userObjectKey}</p>
//       <p>Latitude: {location?.latitude}</p>
//       <p>Longitude: {location?.longitude}</p>
//       {!userExists && <p>User does not exist.</p>}
//     </div>
//   );
// };

// export default TestComponent;

import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDatabase, ref, update } from "firebase/database";
import { dataBase } from "./firebase";

const TestComponent = () => {
  const { userObjectKey } = useParams();
  const [location, setLocation] = React.useState({ latitude: null, longitude: null });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position?.coords?.latitude,
            longitude: position?.coords?.longitude,
          });
        },
        (error) => {
          // console.error("Error getting location", error);
        }
      );
    } else {
      // console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (userObjectKey && location?.latitude && location?.longitude) {
      const userLocationRef = ref(dataBase, `users/${userObjectKey}/userlocation`);

      update(userLocationRef, {
        changeLatitude: location.latitude,
        changeLongitude: location.longitude,
      })
        .then(() => {
          //  console.log("Location data updated successfully at users/${userObjectKey}/userlocation");
        })
        .catch((error) => {
          //console.error("Error updating location data:", error);
        });
    }
  }, [userObjectKey, location]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <p style={{ fontSize: "40px", alignItems: "center" }}>Thank You</p>
    </div>
  );
};

export default TestComponent;
